<script lang="ts">
  import { Home, BookOpen, Settings, Newspaper, Mic } from 'lucide-svelte';
  import { navigationState, navigationActions } from '../stores/navigation';
  import { _ } from 'svelte-i18n';

  let navItems = $state([
    {
      id: 'dashboard',
      label: '',
      icon: Home,
      action: () => navigationActions.goHome()
    },
    {
      id: 'vocabulary',
      label: '',
      icon: BookOpen,
      action: () => navigationActions.goToVocabulary()
    },
    {
      id: 'texts-list',
      label: '',
      icon: Newspaper,
      action: () => navigationActions.goToTexts()
    },
    {
      id: 'speak',
      label: '',
      icon: Mic,
      action: () => navigationActions.goToSpeak()
    },
    {
      id: 'settings',
      label: '',
      icon: Settings,
      action: () => navigationActions.goToSettings()
    },
  ]);

  // Update labels when translation changes
  $effect(() => {
    navItems[0].label = $_('navigation.labels.home');
    navItems[1].label = $_('navigation.labels.vocabulary');
    navItems[2].label = $_('navigation.labels.read');
    navItems[3].label = $_('navigation.labels.speak');
    navItems[4].label = $_('navigation.labels.settings');
  });

  function isActive(itemId: string): boolean {
    return $navigationState.currentView === itemId;
  }
</script>

<nav class="fixed inset-x-0 bottom-0 z-50 safe-bottom">
  <div class="glass-panel w-full border-t border-border/60 px-3 py-1.5 shadow-soft-sm rounded-none">
    <div class="flex items-center justify-around">
      {#each navItems as item}
        <button
          type="button"
          onclick={item.action}
          class={`group relative flex flex-col items-center gap-1.5 px-2.5 py-1.5 tap-target transition-all duration-200 ${
            isActive(item.id)
              ? 'text-foreground'
              : 'text-foreground/60 hover:text-foreground/85'
          }`}
          aria-label={item.label}
          aria-current={isActive(item.id) ? 'page' : undefined}
        >
          <div
            class={`flex h-9 w-9 items-center justify-center rounded-xl transition-all duration-200 ${
              isActive(item.id)
                ? 'bg-primary text-primary-foreground shadow-soft-sm'
                : 'bg-transparent text-current group-hover:bg-muted/60'
            }`}
          >
            <item.icon
              class={`h-5 w-5 transition-transform duration-200 ${
                isActive(item.id) ? 'scale-105' : 'group-hover:scale-105'
              }`}
            />
          </div>
          <span
            class={`pill-indicator px-2.5 py-0.5 text-[0.65rem] font-semibold tracking-wide transition-all duration-200 ${
              isActive(item.id)
                ? 'is-active drop-shadow-sm'
                : 'text-foreground/60'
            }`}
          >
            {item.label}
          </span>
        </button>
      {/each}
    </div>
  </div>
</nav>
